import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { CorrectIcon } from "../../assets/ui-icons";
import Toast from "../toast/toast";

function ResendAction({
  action,
  successNotification,
  errorNotification,
  timeout = 30,
  ...props
}) {
  const [isSending, setIsSending] = useState(false);
  const [isActive, setIsActive] = useState(!!timeout);

  // Set a timeout to prevent spamming. Make the state active again after the timeout.

  return (
    <button
      disabled={!isActive}
      onClick={(e) => {
        e.preventDefault();
        if (action) {
          setIsSending(true);
          action()
            .then((data) => {
              setIsSending(false);
              setIsActive(false);
              if (successNotification) {
                toast.success(<Toast title={successNotification} />, {
                  icon: <CorrectIcon />,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              setIsSending(false);
              if (errorNotification) {
                toast.error(
                  <Toast title={"Error"} description={errorNotification} />,
                );
              }
            });
        }
      }}
      style={{
        color: isActive && !isSending ? "#623CE7" : "#A4A4A4",
      }}
      className="text-ui-blue mr-[16px] text-end text-[14px] ml-auto"
    >
      {isSending ? (
        <>
          <ClipLoader size={10} color="currentColor" className="mr-[4px]" />
        </>
      ) : (
        ""
      )}
      Resend
      {!isActive && (
        <Countdown
          date={Date.now() + timeout * 1000}
          onComplete={() => {
            setIsActive(true);
          }}
          renderer={({ hours, minutes, seconds, completed }) => {
            if (completed) {
              return <></>;
            } else {
              return (
                <span className="text-[13px] ml-[4px]">
                  ({minutes * 60 + seconds} Sec)
                </span>
              );
            }
          }}
        />
      )}
    </button>
  );
}

export default ResendAction;
